import "./BarChart.css";

export type BarDatum = { label: string; value: number; sub?: string };

// Minimal dependency-free vertical bar chart. Bars use the brand gradient,
// height scales to the max value. Hover shows the exact value.
const BarChart = ({ data, height = 160, unit = "" }: { data: BarDatum[]; height?: number; unit?: string }) => {
    const max = Math.max(1, ...data.map((d) => d.value));
    if (!data.length) return <div className="zv-bc-empty">—</div>;

    return (
        <div className="zv-barchart" style={{ height }}>
            {data.map((d, i) => (
                <div className="zv-bc-col" key={i} title={`${d.label}: ${d.value}${unit}${d.sub ? ` · ${d.sub}` : ""}`}>
                    <div className="zv-bc-bartrack">
                        <div className="zv-bc-bar" style={{ height: `${(d.value / max) * 100}%` }}>
                            <span className="zv-bc-val">{d.value}</span>
                        </div>
                    </div>
                    <span className="zv-bc-label">{d.label}</span>
                </div>
            ))}
        </div>
    );
};

export default BarChart;
